import Emeralda1 from "./emeralda (1).webp";
import Emeralda2 from "./emeralda (2).webp";

const emeralda = [Emeralda1, Emeralda2];

export default emeralda;
